{#if isLoggedIn}
  <div class="container has-text-right navbar navbar-end">
    <PopupBtn />
    <Glossar />
    <div class="popover is-popover-bottom nav-popover">
      <button
        class="button is-small popover-trigger"
        on:click="{() => logout()}"
      >
        <span>Ausloggen</span>
        <span class="icon is-small"> <i class="fa fa-times"></i> </span>
      </button>
      <div class="popover-content">
        {#if profile?.email}{profile.email}<br />{/if}
        jetzt abmelden
      </div>
    </div>
    <!-- <button class="button is-small" on:click={() => console.log('userProgess', up)}>
    <span>UP</span>
  </button> -->
    <!-- 
    <div class="navbar-item has-dropdown is-hoverable">
      <a class="navbar-link">
      Profil
      </a>
      <div class="navbar-dropdown">
          <a class="navbar-item">
          Logout
          </a>
      </div>
    </div> -->
  </div>
{/if}

<script>
import { push } from "svelte-spa-router";
import { loggedIn, userProfile } from "./stores";
import PopupBtn from "./general/PopupBtn.svelte";
import { authSvc, demoSvc } from "./services";
import Glossar from "./Glossar.svelte";

let isLoggedIn = false,
  profile;
loggedIn.subscribe((status) => (isLoggedIn = status));
userProfile.subscribe((data) => (profile = data));

const logout = () => {
  loggedIn.set(false);
  push("/login");
  demoSvc.isLiveInstance() && authSvc.logout();
};
</script>
